import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IMessageResponse } from '_core/types';
import { GenerateTokenSmsTypes } from '../Types';

const machine = Machines.onGenerateTokenSms.machine;

export const generateTokenSms = (
  params: GenerateTokenSmsTypes.GenerateTokenSmsServiceRequestType,
): Promise<IMessageResponse> => {
  return callServiceMachine(machine, params);
};

export default { generateTokenSms };
